import fetch from '@/apiconfig/index'

export function ocompanyGetLogoByCode(parameter) {
  return fetch({
    url: '/api/companystaff/ocompany/getLogoByCode',
    method: 'get',
    params: parameter,
  })
}
export function getEOCompanyList(parameter) {
  return fetch({
    url:
      '/api/companystaff/ecompanyCostRules/selectEcompanyCostRulesByEcompanyId',
    method: 'get',
    params: parameter,
  })
}
export function saveSpecialDeduction(data) {
  return fetch({
    url: '/api/companystaff/specialAdditionalDeduction/add',
    method: 'post',
    data: data,
  })
}
export function updateSpecialDeduction(data) {
  return fetch({
    url: '/api/companystaff/specialAdditionalDeduction/update',
    method: 'post',
    data: data,
  })
}
export function delSpecialDeduction(id) {
  return fetch({
    url: '/api/companystaff/specialAdditionalDeduction/delete/' + id,
    method: 'delete',
  })
}
export function getSpecialAdditionalDeduction(parameter) {
  return fetch({
    url: '/api/companystaff/specialAdditionalDeduction/getByEmployeeAccountId',
    method: 'get',
    params: parameter,
  })
}
export function calculateTax(data) {
  return fetch({
    url: '/api/emolument/emolument/calculateTax',
    method: 'post',
    data: data,
  })
}
